import React, {useEffect} from 'react';
import {observer} from "mobx-react";

import {AppModuleContentWidgets} from "./app-module.content-widgets";
import {AppModuleContentWebsite} from "./app-module.content-website";
import {DeviceViewModel} from "../../models/device.view-model";
import {AppModuleProps} from "../models/app-module.props";
import {UserAgentViewModel} from "../../models/user-agent.view-model";
import {DebugModuleAsync} from "../modules/debug-module/components/debug-module.async";
import '../styles/app-module.widgets.scss';
import {debounce} from "../../../infrastructure/debounce/debounce";
import {APP} from "../consts";

export class AppModuleRouterContainerComponentProps extends AppModuleProps {
  device: DeviceViewModel;
  userAgent: UserAgentViewModel;
}

export const AppModuleRouterContainer = observer(({controller, userAgent}: AppModuleRouterContainerComponentProps) => {
  const {domUtils, state, device} = controller;

  //TODO: Fix it, performance issue, makes reflow each change
  useEffect(() => {
    if (state.settings.isWidget) {
      domUtils.setContainerClass('scores365');
    } else {
      let bodyClass = `${device.isRtl ? 'didomi-rtl' : 'didomi-ltr'}`

      domUtils.addBodyClass(bodyClass);
      document.documentElement.setAttribute("lang", state.locale?.language?.cultureName);
      document.documentElement.setAttribute("dir", device.isRtl ? 'rtl' : 'ltr');
    }
    document.documentElement.setAttribute("data-theme", state.theme);

  }, [device.isRtl, state.theme])


  const widgetsProps = {
    controller,
    onWidgetVisible: debounce(() => {
      controller.action(APP.ACTION_TYPES.widgetView);
    }, 500)
  };

  return (
    <div
      className={`app-module-router-container scores365app ${device.isRtl ? 'direction-rtl' : 'direction-ltr'} ${!userAgent?.isHandset ? 'support-hover' : ''}`}>
      {
        state.settings.isWidget && <AppModuleContentWidgets {...widgetsProps}/>
      }
      {
        !state.settings.isWidget && <AppModuleContentWebsite controller={controller}/>
      }
      {
        state.isDebugVisible ? <DebugModuleAsync/> : null
      }
    </div>
  )
});
